export const beatsToMs = (beats: number, bpm: number): number => (beats / bpm) * 60_000;

export const beatsPerSample = (bpm: number, sampleRate: number): number => bpm / sampleRate / 60;
